<script lang="ts" setup>
import type { SizeVariants } from '~kui/types/kui';

interface Props {
  errorMessages: string[];
  fontSize?: Extract<SizeVariants, 'sm' | 'md' | 'lg'>;
  id?: string;
}

const props = withDefaults(defineProps<Props>(), {
  fontSize: 'md',
  id: undefined,
});

const generatedId = useId();
const errorsId = computed(() => props.id ?? generatedId);

const variantClasses = computed((): string =>
  twMerge(
    cva('text-destructive', {
      variants: {
        fontSize: {
          sm: 'text-sm',
          md: 'text-sm',
          lg: 'text-lg',
        },
      },
    })({
      fontSize: props.fontSize,
    }),
  ),
);
</script>

<template>
  <!--
    role="alert" makes screen readers announce the errors even though most parents only
    mount this component once errors exist; the explicit aria-live="polite" downgrades the
    announcement priority and aria-atomic re-reads the full list when async errors arrive late.
  -->
  <ul
    :id="errorsId"
    class="mt-2"
    role="alert"
    aria-live="polite"
    aria-atomic="true"
  >
    <li
      v-for="(message, i) in errorMessages"
      :key="`error-${i}`"
      :class="variantClasses"
    >
      {{ message }}
    </li>
  </ul>
</template>
